/**
 * Checks if the application is running locally
 */
export const IS_DEV = import.meta.env.DEV;

/**
 * Get Studio Classic URL to help navigate between the two applications
 * Handle local and prod environments
 */

const STUDIO_PROD = import.meta.env.STUDIO_URL;
const STUDIO_STAGING = 'https://studio-staging.appcues.com';
const STUDIO_LOCAL = 'http://localhost:3007';

export const getStudioUrl = (): string => {
  const isStaging = window.location.origin.includes('studio5-staging');

  if (isStaging) {
    return STUDIO_STAGING;
  }

  if (IS_DEV) {
    return STUDIO_LOCAL;
  }

  return STUDIO_PROD;
};

const AGENT_STUDIO_PROD =
  import.meta.env.AGENT_STUDIO_URL ?? 'https://app.appcues.com';
const AGENT_STUDIO_EU = 'https://app.eu.appcues.com';
const AGENT_STUDIO_STAGING = 'https://agent-studio-staging.appcues.com';
const AGENT_STUDIO_LOCAL = 'http://localhost:3009';

export const getAgentStudioUrl = (): string => {
  const { origin } = window.location;

  const isStaging =
    origin.includes('studio5-staging') || origin.includes('studio-staging');

  if (isStaging) {
    return AGENT_STUDIO_STAGING;
  }

  if (IS_DEV) {
    return AGENT_STUDIO_LOCAL;
  }

  const isEu =
    origin.includes('.eu.') || import.meta.env.AWS_REGION === 'eu-central-1';

  if (isEu) {
    return AGENT_STUDIO_EU;
  }

  return AGENT_STUDIO_PROD;
};
